import { RefreshCw, X } from 'lucide-react'
import { usePWAUpdate } from '@/hooks/usePWAUpdate'

export function PWAUpdatePrompt() {
    const { needRefresh, updateSW, close } = usePWAUpdate()

    if (!needRefresh) return null

    return (
        <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-3 rounded-full border border-border-light/30 dark:border-border-dark/30 bg-surface-light/95 dark:bg-surface-dark/95 shadow-lg backdrop-blur-md animate-in slide-in-from-bottom-5 fade-in duration-300">
            <RefreshCw className="w-5 h-5 text-blue-500" />
            <p className="text-text-primary text-sm font-medium">Update available</p>
            <button
                onClick={updateSW}
                className="ml-1 px-3 py-1 text-sm font-medium rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-colors flex-shrink-0"
            >
                Reload
            </button>
            <button
                onClick={close}
                aria-label="Dismiss update prompt"
                className="p-1 text-text-secondary hover:text-text-primary transition-colors flex-shrink-0"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    )
}
